import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import {
  IAutoCompleteOnFetchEnd,
  IAutoCompleteOnSet,
} from '../../../shared/directives/auto-complete/auto-complete.interface';
import {
  ITrackingAction,
  ITrackingObject,
} from '../../../tracking/tracking.data';
import { FormAlignmentsEnum } from '../../form-master.enum';
import { FormFieldComponent } from '../form-field/form-field.component';

@Component({
  selector: 'app-textarea-field',
  templateUrl: 'textarea-field.component.html',
  styleUrls: ['textarea-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextareaFieldComponent extends FormFieldComponent {
  @Input() alignment: FormAlignmentsEnum;
  @Input() label: string;
  @Input() hideLabel: boolean;
  @Input() fieldId: string;
  @Input() placeholder: string;
  @Input() condensed: boolean;
  @Input() description: string;
  @Input() fieldControl: AbstractControl;
  @Input() options: any;
  @Input() focusableTrigger$: Observable<void>;
  @Input() fieldTriggerLabel: string;
  @Input() hideFieldIfNoInitialValue: boolean;
  @Input() readOnly: boolean;
  @Input() rightIcon: IIcon;
  @Input() textareaE2eId: string;
  @Input() toggleActionE2eId: string;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;
  @Input() triggerTrackingAction: ITrackingAction;
  @Input() maxlength = -1; // unlimited by default
  @Input() noMaxHeight: boolean;
  @Input() removeNativeAutocomplete: boolean;

  @Output() onFocus: EventEmitter<string> = new EventEmitter<string>();
  @Output() onBlur: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  onAutoCompleteFetchStart: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  onAutoCompleteFetchEnd: EventEmitter<IAutoCompleteOnFetchEnd> = new EventEmitter<IAutoCompleteOnFetchEnd>();
  @Output()
  onAutoCompleteSet: EventEmitter<IAutoCompleteOnSet> = new EventEmitter<IAutoCompleteOnSet>();
  @Output() onAutoCompleteHide: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  onAutoCompleteDestroy: EventEmitter<void> = new EventEmitter<void>();

  visibilityTriggered: boolean;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    translateService: TranslateService
  ) {
    super(_changeDetectorRef, translateService);
  }

  showField() {
    this.visibilityTriggered = true;
    this.fieldControl.markAsDirty();

    this._changeDetectorRef.markForCheck();
  }
}
